export const LiveImageIcon = ({
  color = 'white',
  size = 24,
  className,
}: {
  color?: string
  size?: number
  className?: string
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      fill="none"
    >
      <g>
        <path
          d="M12 4.5C12.2761 4.5 12.5 4.72386 12.5 5C12.5 5.27614 12.2761 5.5 12 5.5H9C7.067 5.5 5.5 7.067 5.5 9V12.9141C5.9281 13.19 6.45085 13.4667 6.96973 13.6895C7.67372 13.9917 8.33821 14.1883 8.72168 14.1885C9.51328 14.1885 10.4086 13.8404 11.415 13.0869L11.4189 13.085L11.6436 12.9326C12.77 12.1949 13.9398 11.8318 15.1348 11.8506C16.2495 11.8681 17.3764 12.2167 18.5 12.8877V11.3203C18.5 11.0442 18.7239 10.8203 19 10.8203C19.2761 10.8203 19.5 11.0442 19.5 11.3203V15C19.5 17.4853 17.4853 19.5 15 19.5H9C6.51472 19.5 4.5 17.4853 4.5 15V9C4.5 6.51472 6.51472 4.5 9 4.5H12ZM15.2617 12.8428C14.1797 12.7895 13.1649 13.1141 12.1699 13.8135C10.9993 14.6892 9.85037 15.1504 8.72168 15.1504C7.77771 15.1503 6.52556 14.6871 5.5 14.0332V15C5.5 16.933 7.067 18.5 9 18.5H15C16.933 18.5 18.5 16.933 18.5 15V13.9805C17.3252 13.2646 16.2589 12.8919 15.2617 12.8428ZM9.46094 7.51367C10.5655 7.51367 11.4609 8.4091 11.4609 9.51367C11.4609 10.6182 10.5655 11.5137 9.46094 11.5137C8.35637 11.5137 7.46094 10.6182 7.46094 9.51367C7.46094 8.4091 8.35637 7.51367 9.46094 7.51367ZM9.46094 8.51367C8.90865 8.51367 8.46094 8.96139 8.46094 9.51367C8.46094 10.066 8.90865 10.5137 9.46094 10.5137C10.0132 10.5137 10.4609 10.066 10.4609 9.51367C10.4609 8.96139 10.0132 8.51367 9.46094 8.51367Z"
          fill={color}
        />
        <path
          d="M16.4908 4.44968C16.5485 4.32482 16.7259 4.32482 16.7836 4.44968L17.5187 6.04021C17.5348 6.07499 17.5627 6.10291 17.5975 6.11898L19.188 6.85405C19.3129 6.91175 19.3129 7.08922 19.188 7.14693L17.5975 7.882C17.5627 7.89807 17.5348 7.92599 17.5187 7.96076L16.7836 9.5513C16.7259 9.67616 16.5485 9.67616 16.4908 9.5513L15.7557 7.96076C15.7396 7.92599 15.7117 7.89807 15.6769 7.882L14.0864 7.14693C13.9615 7.08922 13.9615 6.91175 14.0864 6.85405L15.6769 6.11898C15.7117 6.10291 15.7396 6.07499 15.7557 6.04021L16.4908 4.44968Z"
          fill={color}
        />
      </g>
    </svg>
  )
}
